import { GeneralStyle } from '@website-builder/model/style/general-style';

export class TabsStyle extends GeneralStyle {
  columnGap = '';
  verticalCenter = '';
}
